import React, { useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { useNavigate } from "react-router-dom";
import Header from "../../layout/dashboard/header";
import SubscriptionContent from "../../components/subscription/SubscriptionContent";

const Subscription = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Subscription Management
            </Typography>
          </Stack>
        </Box>
      </Header>

      <SubscriptionContent />
    </>
  );
};

export default Subscription;
